(function () {
  const VARIANT_ID = 51324523839816;

  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#CartDrawer-Checkout2');
    if (!btn) return;

    // stop whatever the original button was going to do
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
    if(window.innerWidth < 830){
              document.querySelectorAll('#upsell_offer, .upsell_offer').forEach(el => {
                  el.style.setProperty('width', '100%', 'important');
                  el.style.setProperty('position', 'absolute', 'important');
                  el.style.setProperty('display', 'block', 'important');
                });
              document.addEventListener('click', async (e) => {
                  const btn = e.target.closest('.upsell_add_btn');
                  if (!btn) return;

                  const variantId = btn.dataset.variantId;
                  btn.textContent = 'Toegevoegd...';
                  btn.disabled = true;

                  try {
                    // Add to cart via AJAX
                    const res = await fetch('/cart/add.js', {
                      method: 'POST',
                      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
                      body: JSON.stringify({ id: variantId, quantity: 1 }),
                      credentials: 'same-origin',
                    });
                    if (!res.ok) throw new Error('Failed to add item');
                    await res.json();

                    // Trigger CartWatcher to refresh cart state
                    await CartWatcher.update();

                    // Trigger UI refresh event
                    document.dispatchEvent(new CustomEvent('cart:refresh'));

                    // Optional: Give user feedback
                    btn.textContent = 'Toegevoegd ✓';
                    setTimeout(() => {
                      btn.textContent = 'Voeg toe aan winkelwagen';
                      btn.disabled = false;
                      // document.querySelector('#CartDrawer-Checkout').click()
                    }, 1500);
                  } catch (err) {
                    console.error('Upsell add failed', err);
                    btn.textContent = 'Fout!';
                    setTimeout(() => {
                      btn.textContent = 'Voeg toe aan winkelwagen';
                      btn.disabled = false;
                      // document.querySelector('#CartDrawer-Checkout').click()
                    }, 1500);
                  }
                });
        }

  })
  // delegate clicks for dynamically-added button
  document.addEventListener('click', async (e) => {
    const btn = e.target.closest('#CartDrawer-Checkout');
    if (!btn) return;
      console.log('ss6');
    // stop whatever the original button was going to do
    e.preventDefault();
    e.stopPropagation();
    if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();

   
      console.log('ss3');

    // guard against double-clicks
    // if (btn.dataset.busy === '1') return;
    btn.dataset.busy = '1';
    btn.setAttribute('aria-busy', 'true');
    btn.disabled = true;

    // loading UI on the live button element
    const spinner = btn.querySelector('.loading-overlay__spinner');
    btn.classList.add('loading');
    if (spinner) spinner.classList.remove('hidden');
    const toggles = document.getElementById("gift-wrap-toggle");
    if (!toggles) return;
     if (toggles.checked) {
      let cart = CartWatcher.get();
      if (!cart) {
        try { cart = await CartWatcher.ready(); } catch {}
      }
      const giftExists = cart?.items?.some(
        item => Number(item.variant_id) === 51576190927176
      );
       if (!giftExists) {
            await fetch('/cart/add.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
              credentials: 'same-origin',
              body: JSON.stringify({ id: 51576190927176, quantity: 1 }),
            });
       }
     }
           console.log('ss1');
    try {
      // ensure we have a cart (fallback to 1 if not available)
      let cart = CartWatcher.get();
      if (!cart) {
        try { cart = await CartWatcher.ready(); } catch { /* ignore */ }
      }
      let qty = Number(Math.max(1, Number(cart?.item_count || 1)));

      let ct = CartWatcher.get();

      let ct_bag = ct?.items?.find(
        item => Number(item.variant_id) === 51324523839816
      );
     
      if(ct_bag){
        qty = Number(qty)-Number(ct_bag.quantity);
       let res = await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: ct_bag.key,
            quantity: qty
          })
        });
          if (!res.ok) throw new Error(`Add to cart failed: ${res.status} ${res.statusText}`);
          await res.json();
      }else{
      let res =  await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify({ id: VARIANT_ID, quantity: qty }),
        });
          if (!res.ok) throw new Error(`Add to cart failed: ${res.status} ${res.statusText}`);
          await res.json();
      }
    

      // go straight to checkout
      setTimeout(function(){
          btn.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
          btn.dataset.busy = '0';
          btn.removeAttribute('aria-busy');
          btn.style.backgroundColor = '#f273a5';
          btn.style.borderColor = '#f273a5';
          btn.querySelector('.button__label').style.color = 'white';
          btn.style.borderRadius = '100px';
          btn.disabled = false;
      },3000)
      setTimeout(function(){
        if(document.querySelector('[vid="51576190927176"] cart-remove-button') != null){
          document.querySelector('[vid="51576190927176"] cart-remove-button').click();
        }
      },5000)
      window.location.href = '/checkout';
    } catch (err) {
      console.error('failed to add + redirect:', err);
      alert('Something went wrong. Please try again.');

      // reset only on failure (success redirects)
      btn.classList.remove('loading');
      if (spinner) spinner.classList.add('hidden');
      btn.dataset.busy = '0';
      btn.removeAttribute('aria-busy');
      btn.disabled = false;
    }
  }, true); // capture=TRUE helps beat other handlers if needed
})();


function moveDonationBanner() {
  const banner = document.querySelector('.donation-banner');
  const testimonial = document.querySelector('.product-testimonial-videos');
  const mediaWrapper = document.querySelector('.grid__item.product__media-wrapper');

  if (!banner || !testimonial || !mediaWrapper) return;

  if (window.innerWidth < 490) {
    if (!testimonial.contains(banner)) {
      testimonial.appendChild(banner);
    }
  } else {
    if (!mediaWrapper.contains(banner)) {
      mediaWrapper.appendChild(banner);
    }
  }
}


window.addEventListener('load', moveDonationBanner);
window.addEventListener('resize', moveDonationBanner);

(function () {
  'use strict';

  // --- Private state ---
  let globalCart = null;
  let _initialized = false;
  let _originalFetch = null;
  let _debounceTimer = null;
  let _resolveReady;
  const _ready = new Promise((r) => (_resolveReady = r));

  // --- Public API (attached at the end) ---
  function init(opts) {
    if (_initialized) return;
    _initialized = true;

    const { debounceMs = 120, fetchDelayMs = 100 } = opts || {};
    _monitorShopifyCartUpdates(debounceMs, fetchDelayMs);

    // Prime cache
    update({ fetchDelayMs }).catch((err) =>
      console.error('[cart] initial fetch failed:', err)
    );
  }

  function get() {
    return globalCart;
  }

  function ready() {
    return _ready;
  }

  function isCartMutationRequest(input) {
    try {
      let urlString = '';
      if (typeof input === 'string') urlString = input;
      else if (input && typeof input.url === 'string') urlString = input.url;
      else return false;

      const url = new URL(urlString, location.origin);
      return /\/cart\/(add|change|update|clear|remove)(\.js)?$/.test(url.pathname);
    } catch {
      return false;
    }
  }

  async function update(opts) {
    const { fetchDelayMs = 100 } = opts || {};

    if (fetchDelayMs > 0) {
      await new Promise((r) => setTimeout(r, fetchDelayMs));
    }

    const res = await fetch('/cart.js', {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });

    if (!res.ok) throw new Error(`Failed to fetch cart: ${res.status} ${res.statusText}`);

    const cart = await res.json();
    globalCart = cart;

    if (_resolveReady) {
      _resolveReady(cart);
      _resolveReady = null;
    }

    try {
      document.dispatchEvent(
        new CustomEvent('cart:updated', { detail: { cart, at: Date.now() } })
      );
    } catch {}

    return cart;
  }

  function teardown() {
    if (_originalFetch) {
      window.fetch = _originalFetch;
      _originalFetch = null;
    }
    clearTimeout(_debounceTimer);
    _initialized = false;
  }

  // --- Internals ---
  function _monitorShopifyCartUpdates(debounceMs, fetchDelayMs) {
    if (typeof window === 'undefined' || !window.fetch) return;

    _originalFetch = window.fetch;

    window.fetch = async function patchedFetch(...args) {
      const [input, init] = args;
      const isMutation = isCartMutationRequest(input);
      const resp = await _originalFetch.apply(this, args);

      if (isMutation) {
        // Fire "mutated" for anyone who cares
        try {
          document.dispatchEvent(
            new CustomEvent('cart:mutated', {
              detail: { request: input, init, ok: resp.ok, status: resp.status },
            })
          );
        } catch {}

        if (resp.ok) {
          _debounced(() => update({ fetchDelayMs }), debounceMs);
        }
      }

      return resp;
    };
  }

  function _debounced(fn, wait) {
    clearTimeout(_debounceTimer);
    _debounceTimer = setTimeout(fn, wait);
  }

  // --- Expose minimal global API ---
  window.CartWatcher = {
    init,           // CartWatcher.init({ debounceMs?, fetchDelayMs? })
    get,            // CartWatcher.get() -> latest cached cart (or null)
    ready,          // CartWatcher.ready() -> Promise resolves with first cart
    update,         // CartWatcher.update() -> force refresh
    isCartMutationRequest,
    teardown,       // CartWatcher.teardown() -> restores original fetch
  };

  // Auto-boot on DOM ready (optional—remove if you prefer manual init)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init());
  } else {
    init();
  }
})();


async function removeProductById(targetProductId) {
  if (!CartWatcher.get()) await CartWatcher.ready();
  const cart = CartWatcher.get();
  if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) return null;

  const updates = {};
  cart.items.forEach((item) => {
    const variantId = item.id; // variant ID is what Shopify uses
    updates[variantId] = item.product_id === targetProductId ? 0 : item.quantity;
  });

  const res = await fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
    body: JSON.stringify({ updates }),
    credentials: 'same-origin',
  });

  if (!res.ok) throw new Error(`update failed: ${res.status} ${res.statusText}`);
  return res.json(); // returns the updated cart
}


CartWatcher.ready().then(async (cart) => {
  const targetProductId = 9656570937672;
  const hasTarget = cart.items.some(item => item.product_id === targetProductId);
  const targetProductId2 = 9714397118792;
  const hasTarget2 = cart.items.some(item => item.product_id === targetProductId2);
  if (hasTarget) {
    try {
      await removeProductById(targetProductId);
      window.location.reload();
    } catch (e) {
      console.error('failed to remove product', e);
    }
  } else {
    console.log(`product_id ${targetProductId} not found in cart`);
  }
});


document.addEventListener('cart:updated', (e) => {
   if(document.querySelector('[vid="51576190927176"] cart-remove-button') != null){
          document.querySelector('[vid="51576190927176"] cart-remove-button').click();
    }
});


